import { Box, Button, Grid, Typography } from "@mui/material";
import { Form } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { loginWithMFA, resendMfaCode } from "../../../../actions/login";
import FormikActions from "../../../commons/formik/formikActions";
import FormikForm from "../../../commons/formik/formikForm";
import FormikTextField from "../../../commons/formik/formikTextField";
import useCountdown from "../../../commons/hooks/useCountdown";

const validationSchema = yup.object({
  token: yup.string().required("Campo obligatorio"),
})

const initialValues = {
  token: "",
}

const MFAForm = ({
  handleCancel,
  credentials,
  lastCodeExpirationTime,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth?.loginMfa?.isFetching || false);
  const loadingResend = useSelector((state) => state.auth?.resendMfaCode?.isFetching || false);
  const [hasResent, setHasResent] = useState(false);

  const { countdown: resendSeconds, restartCountdown: restartResendTimer } = useCountdown(10);

  const { countdown: codeExpirationCountdown, restartCountdown: resetCodeExpirationCountdown } = useCountdown(lastCodeExpirationTime);

  const handleSubmitUser = (values) => {
    dispatch(loginWithMFA(values.token, credentials.userName))
      .then(() => navigate("/home"))
      .catch((error) => {

      });
  };

  const handleResendCode = (e) => {
    dispatch(resendMfaCode(credentials)).then((res) => {
      resetCodeExpirationCountdown(res.value.data);
      setHasResent(true);
    })
      .catch((error) => {
        restartResendTimer();
        throw error;
      })
  };

  const getResendButtonText = (seconds) => {
    if (loadingResend) return "Reenviando...";
    if (hasResent) return "Código reenviado";
    if (seconds > 0) return `Reenviar código (${seconds}s)`;
    return "Reenviar código";
  };

  return (
    <>
      <Typography sx={{ fontWeight: 'bold' }} variant="body1" align="left" gutterBottom>
        Verificación en 2 pasos
      </Typography>
      <FormikForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmitUser(values);
        }}>
        {({ values }) => (
          <Form>
            <Typography variant="body2" align="left" gutterBottom>
              Se ha enviado un código de autentificación a su correo electrónico. Por favor, ingrese el código recibido para continuar.
            </Typography>
            <FormikTextField
              name="token"
              label="Código de verificación"
              variant="outlined"
              margin="normal"
              fullWidth
              autoFocus
            />
            {lastCodeExpirationTime && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <Typography variant="body2" align="left" gutterBottom color="error">
                  {codeExpirationCountdown > 0 ? `Su código expira en: ${codeExpirationCountdown}` : "Su código caducó"}
                </Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              {!hasResent &&
                <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                  ¿No recibiste el código?
                </Typography>
              }
              <Button
                variant="text"
                size="small"
                onClick={handleResendCode}
                disabled={resendSeconds > 0 || hasResent || loadingResend}
                sx={{
                  textTransform: 'none',
                  p: 0,
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                {getResendButtonText(resendSeconds)}
              </Button>
            </Box>

            <Grid alignItems="center" justifyContent="center" container >
              <FormikActions
                handleCancel={handleCancel}
                submitText={"Ingresar"}
                disabled={loading}
              />
            </Grid>
          </Form>
        )}
      </FormikForm>
    </>
  );
};

export default MFAForm;